/* eslint-disable prettier/prettier */
import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilAccountLogout,
  cilBriefcase,
  cilLifeRing,
  cilLightbulb,
  cilLocationPin,
  cilPeople,
  cilSettings,
  cilSpeedometer,
  cilUser,
  cilUserPlus,
} from '@coreui/icons'
import { CNavGroup, CNavItem } from '@coreui/react-pro'
import { Translation } from 'react-i18next'

const _nav = [
  {
    component: CNavItem,
    name: <Translation>{(t) => t('Dashboard')}</Translation>,
    to: '/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,

  },
  {
    component: CNavGroup,
    name: <Translation>{(t) => t('User Management')}</Translation>,
    icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Roles',
        to: '/usermanagement/roles/viewrole'
      },
      // {
      //   component: CNavItem,
      //   name: 'Menus',
      //   to: '/usermanagement/menu/viewmenu',
      // },
      // {
      //   component: CNavItem,
      //   name: 'Role-Menu Mapping',
      //   to: '/usermanagement/rolemenumapping',
      // },
      {
        component: CNavItem,
        name: 'Users',
        to: '/usermanagement/users/alluser',
      },
      {
        component: CNavItem,
        name: 'Change Password',
        to: '/usermanagement/changepassword/changepassword',
      },
    ]
  },
  {
    component: CNavGroup,
    name: <Translation>{(t) => t('CMS')}</Translation>,
    icon: <CIcon icon={cilSettings} customClassName='nav-icon' />,
    items: [
      {
        component: CNavItem,
        name: 'All Pages',
        to: './cms/allpages/allpages'
      },
      {
        component: CNavItem,
        name: 'Page Banner',
        to: './cms/pagebanner/pagebanner'
      },
      {
        component: CNavItem,
        name: 'Home Banner',
        to: './cms/homebanner/homebanner'
      },
      {
        component: CNavItem,
        name: 'Gallery',
        to: './cms/gallery/gallerylist'
      },
      {
        component: CNavItem,
        name: 'Leaders',
        to: './cms/leaders/leaderslist'
      },
      {
        component: CNavItem,
        name: 'Offices',
        to: './cms/offices/officeslist'
      },
      {
        component: CNavItem,
        name: 'Donations',
        to: './cms/donations/donationlist'
      },
      {
        component: CNavItem,
        name: 'Awards',
        to: './cms/awards/awardslist'
      },
      {
        component: CNavItem,
        name: 'Key Initiatives',
        to: './cms/keyinitiatves/keyinitiativeslist'
      },

    ]
  },
  {
    component: CNavGroup,
    name: <Translation>{(t) => t('Insight')}</Translation>,
    icon: <CIcon icon={cilLightbulb} customClassName='nav-icon' />,
    items: [
      {
        component: CNavItem,
        name: 'News',
        to: './insights/news/newslist'
      },
      {
        component: CNavItem,
        name: 'Events',
        to: './insights/events/eventslist'
      }
    ]
  },
  {
    component: CNavGroup,
    name: <Translation>{(t) => t('Location')}</Translation>,
    icon: <CIcon icon={cilLocationPin} customClassName='nav-icon' />,
    items: [
      {
        component: CNavItem,
        name: 'Country',
        to: './location/country/countrylist'
      },
      {
        component: CNavItem,
        name: 'State',
        to: './location/state/statelist'
      },
      {
        component: CNavItem,
        name: 'District',
        to: './location/cities/citieslist'
      }
    ]
  },
  {
    component: CNavGroup,
    name: <Translation>{(t) => t('Member Master')}</Translation>,
    icon: <CIcon icon={cilPeople} customClassName='nav-icon' />,
    items: [
      {
        component: CNavItem,
        name: 'Annual Income',
        to: './masters/annualincome/annualincomelist'
      },
      {
        component: CNavItem,
        name: 'Body Type',
        to: './masters/bodytype/bodytypelist'
      },
      {
        component: CNavItem,
        name: 'Category',
        to: './masters/category/categorylist'
      },
      {
        component: CNavItem,
        name: 'Degree',
        to: './masters/degree/degreelist'
      },
      {
        component: CNavItem,
        name: 'Degree Grade',
        to: './masters/degreegrade/degreegradelist'
      },
      {
        component: CNavItem,
        name: 'Designations',
        to: './masters/designations/designationlist'
      },
      {
        component: CNavItem,
        name: 'Employement Nature',
        to: './masters/empnature/empnaturelist'
      },
      {
        component: CNavItem,
        name: 'Gender',
        to: './masters/gender/genderlist'
      },
      {
        component: CNavItem,
        name: 'Marital Status',
        to: './masters/maritalstatus/maritalstatuslist'
      },
      {
        component: CNavItem,
        name: 'Nationality',
        to: './masters/nationality/nationalitylist'
      },
      {
        component: CNavItem,
        name: 'Mother Tongue',
        to: './masters/mothertongue/mothertonguelist'
      },
      {
        component: CNavItem,
        name: 'Occupation',
        to: './masters/occupation/occupationslist'
      },
      {
        component: CNavItem,
        name: 'Relationship',
        to: './masters/relationship/relationshiplist'
      },
      {
        component: CNavItem,
        name: 'Religion',
        to: './masters/religion/religionslist'
      },
      {
        component: CNavItem,
        name: 'Skin Colors',
        to: './masters/skincolors/skincolorslist'
      },
    ]
  },

  {
    component: CNavGroup,
    name: <Translation>{(t) => t('Membership')}</Translation>,
    icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Pending Members',
        to: '/membership/pendingmembers'
      },
      {
        component: CNavItem,
        name: 'Approved Members',
        to: '/membership/approvememberslist'
      },
      {
        component: CNavItem,
        name: 'Rejected Members',
        to: '/membership/rejectedmembers'
      },
    ]
  },
  {
    component: CNavGroup,
    name: <Translation>{(t) => t('Matrimonial')}</Translation>,
    icon: <CIcon icon={cilLifeRing} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Pending Profiles',
        to: '/matrimonial/pendingmembermatrimonial'
      },
      {
        component: CNavItem,
        name: 'Approved Profiles',
        to: '/matrimonial/approvemembermatrimonial'
      },
      {
        component: CNavItem,
        name: 'Rejected Profiles',
        to: '/matrimonial/rejectedprofiles'
      },
    ]
  },
  {
    component: CNavGroup,
    name: <Translation>{(t) => t('Jobs')}</Translation>,
    icon: <CIcon icon={cilBriefcase} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Pending Jobs',
        to: '/jobs/pendingjobs'
      },
      {
        component: CNavItem,
        name: 'Approved Jobs',
        to: '/jobs/approvedjobs'
      },
      {
        component: CNavItem,
        name: 'Rejected Jobs',
        to: '/jobs/rejectedjobs'
      },
    ]
  },

  {
    component: CNavItem,
    icon: <CIcon icon={cilAccountLogout} customClassName='nav-icon' />,
    name: 'Logout',
    to: '/logout' // Assuming your logout component is at /logout 
  }



]

export default _nav
